import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useRouteMatch,
    useParams,
    Redirect
} from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import Cookies from 'universal-cookie';
import 'bootstrap/dist/css/bootstrap.css';
import Global from "./components/Global";
import Home from "./components/Home/Home";
import Login from "./components/Login/Login";
import Start from "./components/Start/Start";
import Record from "./components/Record/Record";

import Country from "./components/ListCompany/Country";
import City from "./components/ListCompany/City";
import Point from "./components/ListCompany/Point";
import Date from "./components/Record/Date";
import Service from "./components/Record/Service";
import Staff from "./components/Record/Staff";
import MyRecord from "./components/Record/MyRecord";


import Analytics from "./components/Analytics/Analytics";
import DateSchedule from "./components/Record/DateSchedule";
import Event from "./components/Events/Event";
import Events from "./components/Events/Events";
import KnowledgeBase from "./components/KnowledgeBase/KnowledgeBase";
import KnowledgeCategories from "./components/KnowledgeBase/KnowledgeCategories";
import Notifications from "./components/Notifications/Notifications";
import ProfileChange from "./components/Profile/ProfileChange";
import Lesson from "./components/KnowledgeBase/Lesson";
import LessonTestPage from "./components/KnowledgeBase/LessonTestPage";
import Support from "./components/Support/Support";
import WorkSchedulePage from "./components/Schedule/WorkSchedulePage";
import SalonSchedule from "./components/Schedule/SalonSchedule";
import Index from "./components/Index";
import WantToWork from "./components/Login/WantToWork";
import MasterDefine from "./components/Login/MasterDefine";
import KnowledgeBase1 from "./components/KnowledgeBase/Category/KnowledgeBase1";
import Chat from "./components/Chat/Chat";
import Event4 from "./components/Events/Event/Event4";
import { withRouter } from "react-router"
import ChiocoinsHistory from "./components/ChiocoinsHistory/ChiocoinsHistory";
import BenefitCafe from "./components/ChiocoinsBenefitCafe/BenefitCafe";
import CreateRecord from "./components/Record/CreateRecord";
import Tips from "./components/Tips/Tips";
import BenefitCafeGet from "./components/ChiocoinsBenefitCafe/BenefitCafeGet";
import StaffOffer from "./components/StaffOffer/StaffOffer";
import Planning from "./components/Planning/Planning";
import Salary from "./components/Salary/Salary";
import HrFeedback from "./components/HrFeedback/HrFeedback";
import ClientSearch from "./components/Record/ClientSearch";
import Vacancies from "./components/Vacancies/Vacancies";
import Marking from "./components/Marking/Marking";

ReactDOM.render(

    <Router>
        <Switch>
            {/*Вход, авторизация, регистрация*/}
            <Route path="/login" children={<LoginFunc/>}/>
            <Route path="/start" children={<Start/>}/>
            <Route path="/want-to-work" children={<WantToWork/>}/>
            <Route path="/master-define" children={<MasterDefine/>}/>

            <Route path="/analytics" children={<Analytics/>}/>
            <Route path="/chats/:chatId?" children={<Chat/>}/>
            <Route path="/chat" children={<Chat/>}/>
            <Route path="/date-schedule" children={<DateSchedule/>}/>

            <Route path="/date-schedule-staffs" children={<WorkSchedulePage/>}/>

            <Route path="/event/:idEvent" children={<EventFunc/>}/>
            <Route path="/events" children={<Events/>}/>
            <Route path="/knowledge-base/:idCategory/lesson/:id/test" children={<LessonTestFunc/>}/>
            <Route path="/knowledge-base/:idCategory/lesson/:id" children={<LessonFunc/>}/>

            <Route path="/knowledge-base/:idCategory" children={<LessonCategoryFunc/>}/>
            <Route path="/chiocoins-history" children={<ChiocoinsHistory/>}/>
            <Route path="/benefit-cafe" children={<BenefitCafe/>}/>
            <Route path="/benefit-cafe-get/:idBenefit" children={<BenefitFunc/>}/>
            <Route path="/create-record" children={<CreateRecord/>}/>
            <Route path="/tips" children={<Tips/>}/>
            <Route path="/planning" children={<Planning/>}/>
            <Route path="/salary" children={<Salary/>}/>
            <Route path="/hr-feedback" children={<HrFeedback/>}/>
            <Route path="/clients" children={<ClientSearch/>}/>
            <Route path="/vacancies" children={<Vacancies/>}/>
            <Route path="/marking" children={<Marking/>}/>

            <Route path="/knowledge-base" children={<KnowledgeCategories/>}/>
            <Route path="/notifications" children={<Notifications/>}/>
            <Route path="/profile" children={<ProfileChange/>}/>
            <Route path="/records" children={<MyRecord/>}/>
            <Route path="/staff-offer" children={<StaffOffer/>}/>
            <Route path="/support" children={<Support/>}/>
            <Route path="/salon-schedule" children={<SalonSchedule/>}/>
            <Route path="/schedule" children={<WorkSchedulePage/>}/>
            <Route path="/exit" children={<Home/>}/>
            <Route path="/" children={<Home/>}/>


            {/*<Route path="/record" children={<Record/>}/>*/}
            {/*/!*<Route path="/statistics" children={<MyStatistics/>}/>*!/*/}
            {/*<Route path="/country" children={<Country/>}/>*/}
            {/*<Route path="/city" children={<City/>}/>*/}
            {/*<Route path="/point/:idPoint" children={<PointFunc/>}/>*/}
            {/*<Route path="/point" children={<Point/>}/>*/}
            {/*<Route path="/date" children={<Date/>}/>*/}
            {/*<Route path="/date" children={<Date/>}/>*/}
            {/*<Route path="/service" children={<Service/>}/>*/}
            {/*<Route path="/staff" children={<Staff/>}/>*/}
            {/*<Route path="/home" children={<HomeFunc/>}/>*/}

            {/*<Route path="/chat" children={<Chat/>}/>*/}
            {/*<Route path="/profile-create" children={<ProfileCreate/>}/>*/}

        </Switch>
    </Router>,
    document.getElementById('root')
);

function LessonCategoryFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    // eslint-disable-next-line react-hooks/rules-of-hooks
    let {idCategory} = useParams<{ idCategory: string }>();
    return <KnowledgeBase1  idCategory={idCategory}/>;
}
function LessonFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    // eslint-disable-next-line react-hooks/rules-of-hooks
    let {id,idCategory} = useParams<{ id: string; idCategory: string }>();
    return <Lesson idCategory={idCategory}  idLesson={id}/>;
}

function LessonTestFunc() {
    let {id,idCategory} = useParams<{ id: string; idCategory: string }>();
    return <LessonTestPage idCategory={idCategory} idLesson={id}/>;
}

function HomeFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    let {widgetId, idCity} = useParams<{ widgetId: string; idCity: string }>();
    return <Home/>;
}

function LoginFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    let {widgetId, idCity} = useParams<{ widgetId: string; idCity: string }>();
    return <Login/>;
}


function EventFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    let {idEvent} = useParams<{ idEvent: string }>();
    return <Event idEvent={idEvent}/>;
}

function BenefitFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    let {idBenefit} = useParams<{ idBenefit: string }>();
    return <BenefitCafeGet idBenefit={idBenefit}/>;
}

function PointFunc() {
    // We can use the `useParams` hook here to access
    // the dynamic pieces of the URL.

    let {idPoint} = useParams<{ idPoint: string }>();
    return <Point idPoint={idPoint}/>;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
